import {MessageChat} from "./MessageChat";
import {DateFormatter} from "../DateFormatter";

export class MessageChatHolder {
    messages: MessageChat[] = [];
    date: Date;
    display: string;

    constructor(date: any) {
        this.date = new Date(date);
        this.date.setHours(0, 0, 0, 0);
        this.display = new DateFormatter(this.date).formatYear();
    }

    isSameDate(date: Date) {
        let d = new Date(date);
        d.setHours(0, 0, 0, 0);
        return this.date.getTime() === d.getTime();
    }
}
